import { showHidePassword } from './modules/show-hide-password';
import { SvgSprite } from './modules/svg-loader';
import { RevealPanel } from './modules/revealPanel';
import { Accordion } from './modules/accordion';
import { Tabs } from './modules/tabs';
import { MainNavigation } from './modules/mainNavigation';
import { GoogleTranslate } from './modules/google-translate'
import * as YouTubeIframeLoader from 'youtube-iframe';
import './modules/promo-interface';
import './modules/sticky-sidebar-component';
import { QuickDonate } from './modules/quickDonate';
import { HeaderVideo } from './modules/headerVideo';
import { VideoItem } from './modules/videoItem';
import throttle = require('lodash.throttle');
import debounce = require('lodash.debounce');
import { Alert } from './modules/alert';
import { FilterAppInit } from './apps/filter-block/app';
import { ContributorBlock } from './modules/contributorBlock';
import { vhUnitInitial, vwUnitInitial } from './helpers/viewportUnitFix';
import { getScrollbarSize } from './helpers/getScrollbarSize';
import { ShowMore } from './modules/show-more';
import { StickyObserver } from './modules/sticky-observer';

new SvgSprite('/Static/img/adage-sprite.svg');

new GoogleTranslate();

vhUnitInitial();
vwUnitInitial();
showHidePassword();
requestAnimationFrame(() => {
    document.documentElement.style.setProperty('--scrollbar-size', `${getScrollbarSize(true)?.height}px`);
});

const navContainer = document.querySelector('[data-main-nav]') as HTMLElement;
if (!!navContainer) {
    new MainNavigation(navContainer);
}

const initializeGenericComponents = () => {

    const panels = [].slice.call(document.querySelectorAll('[data-panel]')) as HTMLElement[];
    panels.forEach(panel => {
        new RevealPanel(panel);
    });

    const accordions = [].slice.call(document.querySelectorAll('[data-accordion-list]')) as HTMLElement[];
    accordions.forEach(accordionEl => {
        const oneOpenAtATime = accordionEl.getAttribute('data-one-open-at-a-time') == "true";
        new Accordion({ container: accordionEl, oneOpenAtATime: oneOpenAtATime });
    });

    const tabEls = Array.prototype.slice.call(document.querySelectorAll('[data-tabs-container]')) as HTMLElement[];
    tabEls.forEach(tabEl => {
        new Tabs({ container: tabEl });
    })

    const alerts = Array.prototype.slice.call(document.querySelectorAll('[data-alert]')) as HTMLElement[];
    alerts.forEach(alert => {
        new Alert(alert);
    });

    const contributorBlocks = Array.from(document.querySelectorAll<HTMLElement>('[data-contributor-block]'));
    contributorBlocks.forEach(block => {
        new ContributorBlock(block);
    });

    const showMoreContents = Array.from(document.querySelectorAll<HTMLElement>('[data-show-more]'));
    showMoreContents.forEach(content => {
        new ShowMore(content);
    });

    const quickDonateBlocks = [].slice.call(document.querySelectorAll('[data-quick-donate]'));
    quickDonateBlocks.forEach(block => {
        new QuickDonate(block);
    });

    // Header videos
    const headerVideoContainers = Array.prototype.slice.call(document.querySelectorAll('[data-header-video-container]')) as HTMLElement[];
    headerVideoContainers.forEach(HeaderVideoContainer => {
        new HeaderVideo(HeaderVideoContainer);
    });

    // Videos
    const videoItems = Array.prototype.slice.call(document.querySelectorAll('[data-video-item]:not([data-video-type=youtube])')) as HTMLElement[];
    const youtubeVideoItems = Array.prototype.slice.call(document.querySelectorAll('[data-video-item][data-video-type=youtube]')) as HTMLElement[]
    videoItems.forEach(videoItem => {
        new VideoItem(videoItem);
    });
    YouTubeIframeLoader.load(YT => {
        youtubeVideoItems.forEach(youtubeVideoItem => {
            const iframe = youtubeVideoItem.querySelector('[data-youtube-id]');
            const ytvideoPlayer = new YT.Player(iframe.getAttribute('id'), {
                height: '390',
                width: '640',
                videoId: iframe.getAttribute('data-youtube-id'),
                events: {
                    onReady: () => {
                        new VideoItem(youtubeVideoItem, ytvideoPlayer);
                    }
                }
            });

        });

    });
}



initializeGenericComponents();

// Filter Block Init
const filterBlockInit = () => {
    const filterBlocks = Array.from(
        document.querySelectorAll('[data-filter-block]')
    ) as HTMLElement[];

    if (filterBlocks.length > 0) {
        filterBlocks.forEach(filterBlock => {
            FilterAppInit(filterBlock);
        });
    }
};
filterBlockInit();

const stickyNavs = Array.from(document.querySelectorAll('[data-sticky-nav]')) as HTMLElement[];
stickyNavs.forEach(stickyNav => {
    new StickyObserver(stickyNav);
});